import { FC } from "react";
import Sidebar from "../Sidebar";
import "./style.scss";
import Breadcrumb from "../Breadcrumb";

interface LayoutPropTypes {
  children: React.ReactNode;
}

const Layout: FC<LayoutPropTypes> = ({ children }) => {
  return (
    <div className="layout-component-wrapper">
      <div className="left-side">
        <Sidebar />
      </div>
      <div className="right-side">
        <Breadcrumb />
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Layout;
